// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.legend-lg-style {
  width: 100%;
}

.menuIcon {
  padding-top: 15px;
  padding-left: 10px;
}

.iconBox {
  text-align: center;
  padding: 15px;
  cursor: pointer;
  box-shadow: 2px 2px 4px #b6bfbf, -2px -2px 4px #edfbfafa;
}

.iconBox:hover {
  background: #edfbfafa;
  box-shadow: 2px 2px 4px #b6bfbf, -2px -2px 4px #edfbfafa;
}

.excelIcon {
  width: 1em;
  height: 1em;
}
`, "",{"version":3,"sources":["webpack://./src/components/survey/styles/Survey.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,wDAAwD;AAC1D;;AAEA;EACE,qBAAqB;EACrB,wDAAwD;AAC1D;;AAEA;EACE,UAAU;EACV,WAAW;AACb","sourcesContent":[".legend-lg-style {\n  width: 100%;\n}\n\n.menuIcon {\n  padding-top: 15px;\n  padding-left: 10px;\n}\n\n.iconBox {\n  text-align: center;\n  padding: 15px;\n  cursor: pointer;\n  box-shadow: 2px 2px 4px #b6bfbf, -2px -2px 4px #edfbfafa;\n}\n\n.iconBox:hover {\n  background: #edfbfafa;\n  box-shadow: 2px 2px 4px #b6bfbf, -2px -2px 4px #edfbfafa;\n}\n\n.excelIcon {\n  width: 1em;\n  height: 1em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
